<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo">
      <!--<el-menu-item index="1" @click="toNewRouter('custom-payment-over-view')" v-if="permissionCodes.indexOf('015001000') !== -1" >-->
      <!--<i class="el-icon-damai-shujulaiyuan" style="font-size: 16px;"></i>-->
      <!--<span slot="title">概览</span>-->
      <!--</el-menu-item>-->
      <el-menu-item index="1" @click="toNewRouter('video-device')" v-if="permissionCodes.indexOf('020001000') !== -1">
        <i class="el-icon-damai-shipin1"></i>
        <span slot="title">设备管理</span>
      </el-menu-item>
      <el-menu-item index="4" @click="toNewRouter('video-page')" v-if="permissionCodes.indexOf('020001007') !== -1">
        <i class="el-icon-damai-shipintuxiangxinxiku"></i>
        <span slot="title">视频图像</span>
      </el-menu-item>
      <el-menu-item index="2" @click="toNewRouter('video-device-state')" v-if="permissionCodes.indexOf('020002000') !== -1">
        <i class="el-icon-damai-zhuangtairizhi" style="font-size: 20px;"></i>
        <span slot="title">设备状态日志</span>
      </el-menu-item>
      <el-menu-item index="3" @click="toNewRouter('video-services-log')" v-if="permissionCodes.indexOf('020003000') !== -1">
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">操作日志</span>
      </el-menu-item>

      <!-- <div style="line-height: 50px;display: flex;justify-content: flex-start;align-items: center;padding-left: 25px;">
        <i class="el-icon-s-fold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = true" v-if="!isCollapse"></i>
        <i class="el-icon-s-unfold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = false" v-if="isCollapse"></i>
      </div> -->

    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({
  1: ["video-device", "video-device-add", "video-device-modify"],
  2: ["video-device-state"],
  3: ["video-services-log"],
  4: ["video-page"],
});

export default {
  name: "video-service-nav",
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    },
  },
  data() {
    return {
      isCollapse: false,
      permissionCodes: "",
      indexOfRouterNameEntities,
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", (data) => {
      this.isCollapse = data;
    });
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name,
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/VideoServices/VideoServiceNav.vue